import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, ViewChild }
  from '@angular/core';
import {WafCaptchaService} from "../../services/waf/waf-captcha.service";
@Component({
  selector: 'app-waf-captcha-modal',
  templateUrl: './waf-captcha-modal.component.html',
  styleUrls: ['./waf-captcha-modal.component.scss']
})
export class WafCaptchaModalComponent implements AfterViewInit {
  open = false;
  busy = false;
  private resolver?: (value: string | PromiseLike<string>) => void;
  private rejecter?: (reason?: any) => void;
  @ViewChild('container') container?: ElementRef<HTMLElement>;
  constructor(private waf: WafCaptchaService, private cdr: ChangeDetectorRef) {}
  ngAfterViewInit(): void {}
  /** Show the modal, render CAPTCHA, resolve with token when solved. */
  show(): Promise<string> {
    if (this.open) return Promise.reject(new Error('Modal already open'));
    this.open = true;
    this.cdr.detectChanges(); // ensure container exists in DOM
    return new Promise<string>((resolve, reject) => {
      this.resolver = resolve;
      this.rejecter = reject;
      queueMicrotask(async () => {
        if (!this.container) return reject(new Error('Missing container'));
        this.busy = true;
        try {
          const token = await this.waf.render(this.container.nativeElement);
// CAPTCHA solved → close & resolve
          this.open = false;
          resolve(token);
        } catch (err) {
// keep modal open for retry by default; comment next line to keep it
          this.open = false; // or keep it open to allow immediate retry
          reject(err);
        } finally {
          this.busy = false;
          this.cdr.markForCheck();
        }
      });
    });
  }
  /** User cancelled via button or Esc. */
  cancel(): void {
    if (this.rejecter) this.rejecter(new Error('captcha_cancelled'));
    this.open = false;
  }
}
